import cloneDeep from 'lodash/cloneDeep';

import type { File } from './file';
import { initialFile } from './file';

export const mapFile = ({
    EXT,
    ID,
    IMAGE_HEIGHT,
    IMAGE_WIDTH,
    PATH,
    QUESTION_ID,
    REAL_NAME,
    THUMB,
    LINK,
}: any): File => ({
    ...cloneDeep(initialFile),
    id: Number(ID),
    name: REAL_NAME,
    fullPath: PATH,
    thumb: THUMB,
    ext: EXT,
    realName: [REAL_NAME, EXT].join('.'),
    questionId: QUESTION_ID,
    width: IMAGE_WIDTH,
    height: IMAGE_HEIGHT,
    link: LINK,
});
